import "core-js/modules/es.array.push.js";
import { api, post } from './utils';
import UploadFileList from './upload-file-list';
export default {
  name: 'EmapUploadfile',
  components: {
    UploadFileList
  },
  props: {
    /**
     * 文件token,不传则生成随机的新token，传token则自动请求token下已有的文件信息并渲染到页面上
     */
    fileToken: {
      type: String,
      default: ''
    },

    /**
     * 是否只读，默认false
     */
    readonly: {
      type: Boolean,
      default: false
    },

    /**
     * 是否必须上传文件
     */
    required: {
      type: Boolean,
      default: false
    },

    /**
     * 文件上传成功时的钩子,function(response, file, fileList)
     */
    onSuccess: {
      type: Function,
      default: null
    },

    /**
     * 文件列表的类型，text/avatar/picture-card，默认为text
     */
    listType: {
      type: String,
      default: 'text'
    },

    /**
     * 最大允许上传个数，默认没有限制
     */
    limit: {
      type: Number,
      default: 999
    },

    /**
     * 上传文件的大小要求，单位为MB
     */
    size: {
      type: Number,
      default: 0
    },

    /**
     * 上传文件的格式要求
     */
    type: {
      type: Array,
      default: () => []
    },

    /**
     * 是否支持多选文件
     */
    multiple: {
      type: Boolean,
      default: true
    },

    /**
     * 是否启用永忠服务预览所有文件
     */
    canPreviewAllFile: {
      type: Boolean,
      default: false
    },

    /**
     * 永忠服务预览接口url
     */
    yzPreviewUrl: {
      type: String,
      default: ''
    },

    /**
     * 头像尺寸，listType为avatar时可传,类型为数字，单位是px
     */
    avatarSize: {
      type: Number,
      default: 104
    }
  },
  data: vm => ({
    genToken: false,
    // 是否由组件生成token
    action: api.uploadTempFileUrl,
    fileArr: [],
    formData: {
      scope: '',
      fileToken: '',
      storeId: 'file',
      isSingle: '0',
      fileName: '',
      size: vm.size,
      type: vm.type
    },
    deleteUploadedList: [],
    orderMap: {},
    // 预览图片的src列表
    src: '',
    previewSrcList: [],
    wrongType: false
  }),
  computed: {
    uploadClass() {
      return this.listType === 'avatar' ? 'avatar-uploader ' : '';
    },

    showFileList() {
      // 各个显示类型，是否需要文件列表
      const show = {
        text: false,
        'picture-card': true,
        avatar: false
      };
      return show[this.listType];
    },

    avatarSrc() {
      if (this.listType === 'avatar' && this.fileArr.length > 0) {
        return this.fileArr[0].url || '';
      }

      return '';
    }

  },
  watch: {
    fileToken() {
      this.getFileByToken();
    }

  },

  created() {
    this.getFileByToken();
  },

  methods: {
    async getFileByToken() {
      // 如果有token，查询文件
      if (this.fileToken && !this.genToken) {
        try {
          this.formData.fileToken = this.fileToken;
          this.formData.scope = this.fileToken.substring(0, this.fileToken.length - 1); // 先调用一次删除临时文件的接口，以防之前上传了临时文件后直接关闭页面

          await post(api.deleteTempFileUrl, {
            scope: this.formData.scope,
            fileToken: this.formData.fileToken
          }); // 查询已经上传的文件

          const uploadResult = await post(api.getUploadedFileUrl.replace('fileToken', this.formData.fileToken));

          if (uploadResult.success && uploadResult.items) {
            uploadResult.items.forEach(item => {
              this.fileArr.push({
                name: item.name,
                url: item.fileUrl,
                emapId: item.id,
                tempFile: false,
                successFlag: true,
                size: item.size,
                isImage: item.isImage,
                percentage: 100
              });
            }); // 更新需要保存的文件列表

            this.orderMap = this.updateOrderMap(this.fileArr);
          }
          /**
           * 传入token时，文件加载完毕之后触发，参数为文件列表
           */


          this.$emit('file-load', this.fileArr);
        } catch (error) {
          this.$message.error(error);
        }
      }
    },

    beforeUpload(file) {
      // check file size
      if (this.size && file.size / 1024 / 1024 > this.size) {
        this.$message.error(`文件大小不得超过${this.size}MB!`);
        return false;
      } // check file type


      if (file.name && this.type && this.type.length > 0) {
        const name = file.name.toUpperCase();
        const checkResult = this.type.map(el => name.endsWith(el.toUpperCase()));

        if (!checkResult.includes(true)) {
          this.$message.error(`文件类型必须为 ${this.type}!`);
          this.wrongType = true;
          return false;
        }
      } // 处理请求参数，只需要生成一次scope和token


      if (!this.formData.fileToken) {
        this.formData.scope = new Date().getTime() + '' + parseInt(Math.random() * 100).toString();
        this.formData.fileToken = this.formData.scope + 1;
        /**
         * 请使用.sync自动接收fileToken
         * @arg  token:组件生成的fileToken
         */

        this.$emit('update:fileToken', this.formData.fileToken);
        this.genToken = true;
      }
    },

    // 文件上传过程中的钩子
    handleProgress(event, file, fileList) {
      this.fileArr = fileList;
      this.fileArr.forEach(item => {
        if (item.percentage !== 100) {
          item.progressFlag = true;
          item.progressPercent = Math.abs((item.percentage ? item.percentage : 0).toFixed(0));
        }
      });
    },

    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if (!response.success) {
        this.$message.error(response.error);
      } // emap后台上传接口、组件上传必须同时成功


      file.progressFlag = false;

      if (response.success && file.status === 'success') {
        file.emapId = response.id;
        file.url = response.tempFileUrl;
        file.isImage = response.isImage;
        file.tempFile = true;
        file.successFlag = true;
      } else {
        file.successFlag = false;
      } // file会自动添加到fileList中


      this.fileArr = fileList; // 更新需要正式保存的文件列表

      this.orderMap = this.updateOrderMap(this.fileArr);

      if (this.onSuccess && typeof this.onSuccess === 'function') {
        this.onSuccess(response, file, fileList);
      } // 显示类型为头像上传时，多次上传需要覆盖掉之前上传成功的头像


      if (this.listType === 'avatar' && this.fileArr.length > 1) {
        this.handleRemove(this.fileArr[0], this.fileArr.slice(1));
      }
    },

    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      // beforeuUpload钩子return false后总是会执行beforeRemove
      console.log(fileList);

      if (!this.wrongType) {
        return this.$confirm(`确认要删除 ${file.name} 吗？`);
      }
    },

    // 文件列表移除文件，非钩子，自定义方法
    async handleRemove(file, fileList) {
      // upload组件内部已经进行了删除，直接赋值
      this.fileArr = fileList; // 调用emap删除临时文件接口

      if (file.tempFile) {
        const deleteResult = await post(api.deleteTempFileUrl, {
          fileWid: file.emapId,
          scope: this.formData.scope,
          fileToken: this.formData.fileToken,
          attachmentParam: JSON.stringify({
            storeId: 'file',
            scope: this.formData.scope,
            fileToken: this.formData.fileToken
          })
        });

        if (!deleteResult.success) {
          this.$message.error(deleteResult.error);
        }
      } else {
        this.deleteUploadedList.push(file.emapId);
      } // 更新需要保存的文件列表


      this.orderMap = this.updateOrderMap(this.fileArr);
    },

    handleRemoveCustom(file) {
      // listType=text时，展示自定义的文件列表，需要手动触发删除文件的钩子
      this.$refs.emapUploadFile.handleRemove(file, file);
    },

    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      console.log(files, fileList);
      this.$message.warning(`只允许上传${this.limit}个文件!`); // this.$message.warning(
      //   `当前限制选择${this.limit}个文件，本次选择了 ${
      //     files.length
      //   } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      // );
    },

    /**
     * 保存附件为正式文件，需要手动调用
     * @vuese
     */
    async saveAttachment() {
      const result = {
        success: false
      };

      if (Object.keys(this.orderMap).length === 0) {
        if (this.required) {
          this.$message.error('附件不得为空，请上传文件');
        } else {
          result.success = true;
        }
      } // 删除正式文件


      for (const id of this.deleteUploadedList) {
        // regularSize
        await post(api.deleteUploadedFileUrl.replace('fileId', id)); // middleSize

        await post(api.deleteUploadedFileUrl.replace('fileId', id + '_1')); // smallSize

        await post(api.deleteUploadedFileUrl.replace('fileId', id + '_2'));
      } // 保存正式文件


      if (Object.keys(this.orderMap).length > 0) {
        const saveResult = await post(api.saveAttachmentUrl.replace('scope', this.formData.scope).replace('fileToken', this.formData.fileToken), {
          attachmentParam: JSON.stringify({
            storeId: 'file',
            scope: this.formData.scope,
            fileToken: this.formData.fileToken,
            orderMap: this.orderMap
          }),
          widsOfAttsToDelete: this.deleteUploadedList.length > 0 ? this.deleteUploadedList.join(',') : ''
        });

        if (!saveResult.success) {
          this.$message.error(saveResult.error);
        }

        result.success = saveResult.success;
      }

      return result;
    },

    updateOrderMap(fileList) {
      const newOrder = {};
      fileList.forEach((obj, index) => {
        newOrder[obj.emapId] = index + 1;
      });
      return newOrder;
    },

    async handlePreview(item) {
      if (item.isImage) {
        this.src = item.url;
        this.previewSrcList = [item.url]; // 调用image组件的预览

        this.$nextTick(() => {
          this.$refs.imagePreviewer.clickHandler();
        });
      } else if (item.yongzhongPreview) {
        // 永忠预览各种类型的文件
        // 如果没有传预览地址，则取OA的默认预览地址
        try {
          const loading = this.$loading({
            lock: true
          });
          const result = await post(this.yzPreviewUrl || api.defaultYzPreviewUrl, {
            fileWid: item.emapId,
            file: encodeURIComponent(item.url),
            ext: item.name.split('.').pop() || ''
          });
          loading.close();

          if (result && result.code === '1') {
            window.open(result.data);
          } else {
            console.error('永忠预览失败');
          }
        } catch (error) {
          console.error(error);
        }
      } else if (/\.pdf$/.test(item.name.toLowerCase())) {
        // 调用emapcomponent预览pdf接口
        const url = api.previewPDFUrl.replace('fileUrl', encodeURIComponent(item.url));
        window.open(url);
      }
    }

  }
};